import React from 'react'
import styled from 'styled-components'
import UniselectionOption from '~/components/Buttons/ExplicitSelectionButton/Uniselection/UniselectionOption/UniselectionOption'
import { Option } from '~/components/Buttons/ExplicitSelectionButton/type'
import Text from '~/components/Text'
import SafeHtmlContent from '~/utils/SafeHtmlContent'
import Accordion from '../../Accordion/Accordion'
import { AccordionWrapper } from '../../styles'
import { ExplicitUniselectionAccordionProps } from '../type'

const TextAlignJustify = styled.span`
  display: block;
  text-align: justify;
`

const ExplicitUniselectionAccordion = ({
  textContentVariant = 'content-03',
  labelTextVariant = 'bordertext-emphasis-04',
  defaultOpenedIndexes,
  checkedOption = '',
  accordionHeightClass = 'small',
  radioButtonHeightClass = 'regular',
  options,
  required,
  disabled,
  hideAccordionArrowOnDisable = false,
  optionLabelsPosition,
  onChange,
  ...uniselectionOptionProps
}: ExplicitUniselectionAccordionProps) => {
  const onChangeOption = (optionValue: Option, event?: React.MouseEvent) => {
    const target = event?.target as Element
    if (target?.nodeName === 'INPUT') {
      event?.stopPropagation()
    } else {
      event?.preventDefault()
    }
    onChange(optionValue)
  }

  const isBeforePositioned =
    optionLabelsPosition === 'top' || optionLabelsPosition === 'left'

  return (
    <AccordionWrapper>
      <Accordion
        items={options}
        heightClass={accordionHeightClass}
        defaultOpenedIndexes={defaultOpenedIndexes}
        disabled={disabled}
        hideArrowOnDisable={hideAccordionArrowOnDisable}
        allowInteractionOnlyOnIconClick
        renderAccordionTitle={({ option, index }) => (
          <UniselectionOption
            key={index}
            index={index}
            option={option}
            onChange={onChangeOption}
            required={required}
            isBeforePositioned={isBeforePositioned}
            heightClass={radioButtonHeightClass}
            optionLabelsPosition={optionLabelsPosition}
            disabled={disabled}
            checkedOption={checkedOption}
            direction='vertical'
            shouldShowOption={() => true}
            labelTextVariant={labelTextVariant}
            {...uniselectionOptionProps}
          />
        )}
        renderAccordionDescription={({ option }) => (
          <TextAlignJustify>
            <Text variant={textContentVariant}>
              <SafeHtmlContent html={option.complement || ''} />
            </Text>
          </TextAlignJustify>
        )}
      />
    </AccordionWrapper>
  )
}

export default ExplicitUniselectionAccordion
